import type { ReactNode } from 'react';
import { Form } from '@ff-it/form';
import { LoadingContainer } from '@ff-it/ui';
import { Breadcrumb, Page } from 'components';
import { formClassName } from './style.css';
import type { Handler } from './types';

type FormContainerProps = Omit<Handler<any>, 'url'> & {
  title: ReactNode;
  children: ReactNode;
};
export function FormContainer({ title, isLoading, initialValues, onSubmit, disabled, children }: FormContainerProps) {
  return (
    <Page className="scene flex-grow-1 d-flex flex-column">
      <Breadcrumb to={null}>Create</Breadcrumb>
      <LoadingContainer loading={isLoading} className="flex-grow-1 flex-column d-flex">
        {initialValues && (
          <Form initialValues={initialValues} onSubmit={onSubmit} className={formClassName} disabled={disabled}>
            {children}
          </Form>
        )}
      </LoadingContainer>
    </Page>
  );
}
